import { useContext } from 'react';
import AccountContext from 'context/AccountContext';

const useUserPermitById = (permitId: string | undefined) => {
  const {
    customer: { permits },
  } = useContext(AccountContext);

  return permits?.find((permit) => permit && permit.id === permitId) ?? null;
};

export default useUserPermitById;
